import React from 'react'
import { Col, Row } from 'react-bootstrap'
import RecentInvoices from '../../components/dashboard/recentInvoices'
import DirectorPicker from '../../components/dashboard/directorPicker'
import TeamTimesheets from '../../components/dashboard/teamTimesheets'
import { TestingStaff } from './dashboardWrapper'

const ExecAssistDashboard = () => {
	const [director, setDirector] = React.useState<null | TestingStaff>(null)

	return (
		<Row className="py-3">
			<Col sm={4}>
				<Row>
					<Col>
						<DirectorPicker director={director} setDirector={setDirector} />
					</Col>
				</Row>
				<Row className="pt-3">
					<Col>
						<TeamTimesheets firmView={false} testingStaff={director || undefined} onEADashboard={true} />
					</Col>
				</Row>
			</Col>
			<Col sm={8}>
				<RecentInvoices directorXpmID={director?.xpmID} showMonthCount />
			</Col>
		</Row>
	)
}

export default ExecAssistDashboard
